module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh-bot",
    attrs: {
      "id": "ch4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Four")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Seventy miles separated Port Townsend from the Seattle-Tacoma airport. The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping")]), _vm._v(" crew landed in early morning darkness and rented a minivan to accommodate the photography equipment. Suki drove to the Seattle Ferry Terminal, where they caught a ferry to Bainbridge Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki and Michael ate pastries in the ferry’s café for their breakfast. A boy of about three stared at Suki, his gaze traveling from her studded leather bracelets to her face. She puckered her lips at him and he smiled delightedly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus drank only tea. While his staff went out on deck, he sat inside and stared into his teacup, avoiding any view of the bobbing horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Halfway through the trip, Michael came back in and took a moment to stand in front of Angus, swaying to the boat’s movement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sit down if you’re going to stay,” Angus snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael switched to swaying in counterpoint. “What’s the matter, Angus? I thought most Scots had Viking blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus swallowed thickly. “They learned you can only reproduce if you get off the boat and stay put.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s ridiculous,” Suki said, joining them. “The motion adds to the experience.” She raised the camera that hung on a strap around her neck and snapped a picture of Angus’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He groaned and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael sat on the bench opposite Angus. “What’s the plan? Get settled today and do the interview tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus put his cup on the table. “We’re seeing Doreene Gray today, but it’s not exactly an interview.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki sat next to Michael. “What is it, exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“An invitation-only press conference,” Angus said, “and we don’t have an invitation.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wish you’d told me,” Suki said. “I didn’t pack any clothes for crashing press conferences.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m sure you’ll figure something out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael held up a hand. “Wait a minute. Did you even "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("ask")]), _vm._v(" for an interview before deciding to just show up? How do you know she won’t talk to us?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Because Doreene Gray comes from money, and she’s trying to sell a painting to moneyed people.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ah.” Michael nodded. “So she won’t want the tone of the event compromised by our piddling magazine.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Piddling "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("paranormal")]), _vm._v(" magazine,” Suki corrected. “I thought the painting’s big selling point was that it was spooky.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus gave a wry smile. “A mystery is only mysterious if you don’t overpromote. Also, the sale is being handled by Rothwell’s, and they’ll err on the side of tasteful. Don’t expect to see signs that say, "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THIS WAY TO THE POSSESSED PAINTING!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki rested her camera on the table. “If this press conference is invitation-only, how did you find out about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I subscribe to a Web site that leaks that kind of information,” Angus said. “It’s run by personal assistants and gophers. Poor things, they have to make a living somehow.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael took off his glasses and rubbed the bridge of his nose. “You’re telling me we flew all the way out here on the off chance that we can get into an event?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus tapped a finger on the table. “A journalist makes his own opportunities. At the very worst, we’ll have photos of the house and Port Townsend and there’s a boat festival going on right now. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping")]), _vm._v(" is a travel magazine, too, don’t forget.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What about the portrait itself?” Michael asked. “How are we going to do an article if we don’t have a photo of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus’s eyes slid away. “I imagine there will be photos available online after the press conference.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, no,” Suki said. “I draw the line at taking someone else’s work.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus smiled at her. “I would never ask you to do such a thing, but don’t photographers ever share work? You might be able to chat someone up and come to an arrangement.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki considered that. “Do I get a drinks allowance?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Naturally.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Then I’ll see what I can do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus folded his hands on the table. “If all else fails, Suki can get a photo of Doreene Gray as she leaves to do her shopping, and we’ll use that to make our own version of the painting. We’ll put a wee label underneath—"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ARTIST’S")]), _vm._v(" "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RENDERING.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael laughed. “That’s pretty funny, actually.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecbd406e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 81
// module chunks = 0